/*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * SDMO-5859 CR-53 - CP - for SNAP-Only changes
 *
 * This contains all the text for Apply for SNAP without an Account component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
   SNAP_Title: {
    id: 'SNAP_Title',
    defaultMessage: 'Verify SNAP',
  },
     SNAPFORM_Title: {
    id: 'SNAPFORM_Title',
    defaultMessage: 'Verify SNAP Form',
  },
 applicationOverviewAriaLabel: {
    id: 'ApplicationOverview_ApplicationOverviewAriaLabel',
    defaultMessage: 'Application Overview',
  },
  overviewTitle: {
    id: 'ApplicationOverview_LabelOverviewTitle',
    defaultMessage: 'Overview',
  },
  overviewSubtitle: {
    id: 'ApplicationOverview_LabelOverviewSubtitle',
    defaultMessage: 'You are applying for the following benefits:',
  },
  stepCount: {
    id: 'ApplicationOverview_stepCount',
    defaultMessage: 'step {count}',
  },
  stepsTitle: {
    id: 'ApplicationOverview_LabelStepsTitle',
    defaultMessage:
      'Please make sure you understand the following steps involved, before continuing:',
  },
  stepOneHeading: {
    id: 'ApplicationOverview_LabelStepOneHeading',
    defaultMessage: 'Prepare',
  },
  stepOneDescription_1: {
    id: 'ApplicationOverview_LabelStepOneDescription_1',
    defaultMessage: "When you apply, you'll need to give us information such as:",
  },
  stepOneDescription_2: {
    id: 'ApplicationOverview_LabelStepOneDescription_2',
    defaultMessage: 'Personal details such as your name, SSN',
  },
  stepOneDescription_3: {
    id: 'ApplicationOverview_LabelStepOneDescription_3',
    defaultMessage: 'Income, wages, lottery winnings',
  },
  stepOneDescription_4: {
    id: 'ApplicationOverview_LabelStepOneDescription_4',
    defaultMessage: 'Expenses such as rent',
  },
  stepOneDescription_5: {
    id: 'ApplicationOverview_LabelStepOneDescription_5',
    defaultMessage: 'Resources such as bank accounts, vehicles',
  },
  stepTwoHeading: {
    id: 'ApplicationOverview_LabelStepTwoHeading',
    defaultMessage: 'Apply',
  },
  stepTwoAlert: {
    id: 'ApplicationOverview_LabelStepTwo_Alert',
    defaultMessage: 'Application time:',
  },
  stepTwoTime: {
    id: 'ApplicationOverview_LabelStepTwo_Time',
    defaultMessage: '10 - 45 minutes to complete.',
  },
  stepTwoDescription_1: {
    id: 'ApplicationOverview_LabelStepTwoDescription_1',
    defaultMessage:
      'We’re almost ready to start. There are just a few more things you should know. You have the right to file the SNAP application by completing your name, address, and electronic signature. However, additional information will be requested from you to complete the application and determine your eligibility. If eligible, benefits will start from the date we receive your name, address, and signature. If you’re applying for SNAP, an interview is required. We’ll contact you to set up the interview.',
  },
  stepTwoDescription_2: {
    id: 'ApplicationOverview_LabelStepTwoDescription_2',
    defaultMessage:
      'If you have previously applied, many of the fields in this application will already be completed using information we have about you and your household. Please make sure that this information is correct, and change it if necessary. Some information cannot be changed here, such as names and birth dates; if they are not correct contact your local office.',
  },
  stepTwoDescription_3: {
    id: 'ApplicationOverview_LabelStepTwoDescription_3',
    defaultMessage:
      "After submitting, you'll get a confirmation message and a copy by email. You can print this for your records.",
  },
  stepThreeHeading: {
    id: 'ApplicationOverview_LabelStepThreeHeading',
    defaultMessage: 'Verify your information',
  },
  stepThreeDescription_1: {
    id: 'ApplicationOverview_LabelStepThreeDescription_1',
    defaultMessage: 'You may need to provide us the following documents as proof:',
  },
  stepThreeDescription_2: {
    id: 'ApplicationOverview_LabelStepThreeDescription_2',
    defaultMessage: 'Identification',
  },
  stepThreeDescription_3: {
    id: 'ApplicationOverview_LabelStepThreeDescription_3',
    defaultMessage: 'Address',
  },
  stepThreeDescription_4: {
    id: 'ApplicationOverview_LabelStepThreeDescription_4',
    defaultMessage: 'Income',
  },
  stepThreeDescription_6: {
    id: 'ApplicationOverview_LabelStepThreeDescription_6',
    defaultMessage: 'Expenses',
  },
  stepThreeDescription_7: {
    id: 'ApplicationOverview_LabelStepThreeDescription_7',
    defaultMessage: 'Resources',
  },
  stepThreeDescription_5: {
    id: 'ApplicationOverview_LabelStepThreeDescription_5',
    defaultMessage:
      "Don't worry if you don't have them in hand, you have up to 30 days to submit them after we receive your application.",
  },
  stepFourHeading: {
    id: 'ApplicationOverview_LabelStepFourHeading',
    defaultMessage: 'Interview',
  },
  stepFourDescription_a: {
    id: 'ApplicationOverview_LabelStepFourDescription_a',
    defaultMessage: 'Schedule and attend an interview.',
  },
  stepFourDescription_b: {
    id: 'ApplicationOverview_LabelStepFourDescription_b',
    defaultMessage:
      "For the Supplemental Nutrition Assistance Program, schedule and complete an interview. You'll need to provide proof of the following:",
  },
  stepFiveHeading: {
    id: 'ApplicationOverview_LabelStepFiveHeading',
    defaultMessage: 'Decision',
  },
  stepFiveDescription: {
    id: 'ApplicationOverview_LabelStepFiveDescription',
    defaultMessage:
      "Once the entire application is received, required verifications have been provided and for SNAP, an interview is completed, we can determine if you qualify for benefits. You will receive a notice informing you of our decision. This may take up to 30 days.",
  },
  stepFiveDescription_1: {
    id: 'ApplicationOverview_LabelStepFiveDescription_1',
    defaultMessage:
      'SNAP – You will receive SNAP benefits within 30 days if you are eligible. If you are eligible, you will receive benefits within 7 days if you meet one of the following:',
  },
  stepFiveDescription_2: {
    id: 'ApplicationOverview_LabelStepFiveDescription_2',
    defaultMessage:
      'Households with gross monthly income less than $150 and resources of $100 or less',
  },
  stepFiveDescription_3: {
    id: 'ApplicationOverview_LabelStepFiveDescription_3',
    defaultMessage:
      'Households with rent, mortgage, and utilities that are more than the household’s gross monthly income and resources.',
  },
  stepFiveDescription_4: {
    id: 'ApplicationOverview_LabelStepFiveDescription_4',
    defaultMessage:
      'Households with migrant or seasonal farm workers with resources of $100 or less, whose income is stopping or starting.',
  },
  finalInfoOne: {
    id: 'ApplicationOverview_LabelFinalInfo',
    defaultMessage: 'You can save your application and come back later to complete it.',
  },
  finalInfoTwo: {
    id: 'ApplicationOverview_finalInfoTwo',
    defaultMessage: '{loginLink} or {signupLink} to save your application progress.',
  },
  finalInfoTwoLoginLink: {
    id: 'ApplicationOverview_finalInfoTwoLoginLink',
    defaultMessage: 'Log in',
  },
  finalInfoTwoSignupLink: {
    id: 'ApplicationOverview_finalInfoTwoSignupLink',
    defaultMessage: 'sign up',
  },
  startButton: {
    id: 'ApplicationOverview_LabelStartButton',
    defaultMessage: 'Start application',
  },
  applyForBenefitsLink: {
    id: 'ApplicationOverview_BackLink',
    defaultMessage: 'Back',
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program',
  },
  startApplicationButtonDisabledAriaLabel: {
    id: 'ApplicationOverview_startApplicationButtonDisabledAriaLabel',
    defaultMessage:
      'An application for these programs is already pending and this program does not allow multiple applications.',
  },
  // captcha changes
  captchaSecurityCode: {
    defaultMessage: 'Security Code',
    id: 'securityCode_text',
  },
    captchaSecurityCodeErrorMessage: {
    id: 'SNAPApplication_captchaSecurityCodeErrorMessage',
    defaultMessage: 'Please enter the text above exactly as it is shown',
  },
   captchSubmitButton: {
    id: 'securityCode_LabelSubmitButton',
    defaultMessage: 'Submit',
  },
  securityCode: {
    id: 'Captcha_Label',
    defaultMessage: 'Please enter the text above',
  },
  SNAPDescription: {
    id: 'SNAP_Label',
    defaultMessage: 'Supplemental Nutrition Assistance Program (SNAP)',
  },
});
